var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex pt-2 pb-0"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('TasksProgressIndicator',{attrs:{"tasks":_vm.tasks.filter((t) => !_vm.hiddenTasks.includes(t.id)),"show-total-progress":false,"use-evercam-loading-indicator":false,"row":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }